// lodash orderBy compares raw code units, which puts 'achref' and 'Émile' after 'Zoe'.
export const sortKey = (value: unknown) =>
  typeof value === 'string'
    ? value
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase()
    : value
